
























































































































































































































































































  import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import AbpBase from '@/lib/abpbase';
  import appconst from '@/lib/appconst';
  import SeverUrl from "@/lib/url";
  import letterInfo from "@/store/entities/jm/hzletteritem";
  import HzContactEdit from "@/views/jm/jobdo/hz/hzcontactedit.vue";
  import HzMailRead from "@/views/sm/hz/hzmailread.vue";
  import elementResizeDetector from "element-resize-detector";
  @Component({
    components:{HzContactEdit,HzMailRead}
  })
  export default class HZLetterEdits extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:String,default:"0"}) letterid:string;
    loadingInstance:boolean=false;
    messageid:string="0";
    pid:string="";
    downloading:boolean=false;
    title:string ="询证函";
    titlename:string="";
    modalWidth=window.innerWidth * 0.7;
    
    currentModel:letterInfo = new letterInfo();
    currentStatus:number=0;
    statusBtn:number=0;
    indexRow:string="";
    indexCol:string="";
    readShow:boolean=false;
    isreply:boolean=false;
    editShow:boolean=false;
    isalert:boolean=false;
    isfile:boolean=false;
    contactid:string="0";
    rdoImport="0";
    headers={
      'Content-Type': 'multipart/form-data'     
    }
    fileId="";
    loading=false;
    headerConfig={Authorization: "Bearer " + window.abp.auth.getToken()};
    postAction=SeverUrl+"api/services/app/hzletter/UpLoadHzLetterFile";
    paraData={hzId:'0',pId:'0',flagAlert:'0'};
    beforeUpload(file) {
      this.paraData.hzId = this.letterid; 
      this.paraData.pId=this.$store.state.jobdo.currjob;
      this.paraData.flagAlert="0";
    }
    beforeAlert(file) {
      this.paraData.hzId = this.letterid; 
      this.paraData.pId=this.$store.state.jobdo.currjob;
      this.paraData.flagAlert="1";
    }
    onSuccess(response,file,fileList){
      var result=response.result;
      if(result.status){
        this.getItem();
      }
      else{
        this.$alert(response.message,'提示',{type:'info'});
      }
    }
    get jobauth(){
       let d= this.$store.state.jobdo.roles;
       if(d.length>0){
          return d[0].checked=='1'?true:false;
       }
       return false;
    }
    editContactInfo(id:any){
      this.contactid=id;
      this.editShow=true;
    }
    baseUrl(url){
        return appconst.remoteServiceBaseUrl+url;
    }
    cellClass({row,column,rowIndex,columnIndex}){
        if(columnIndex === 4||columnIndex === 6){
          return 'padding: 6px;background:	AliceBlue;font-weight:bold';
        }
        else if(columnIndex===5){
          return 'padding: 6px;color:red';
        }
        else{
          return 'padding: 6px';
        }
    }
    get itemList(){
        return [{value:'1',text:'审计组'},{value:'2',text:'本所函证中心'},{value:'3',text:'客户'},{value:'4',text:'其它'}]
    }
    get sendList(){
        return [{value:'1',text:'Email'},{value:'2',text:'传真'},{value:'3',text:'信件'},{value:'4',text:'面函'},{value:'5',text:'其它'}]
    }
    cellClassName({row, column, rowIndex, columnIndex}){
        row.index = rowIndex;
        column.index = columnIndex;
    }
    uploadRules={
      sendWay:[{required:true,validator: this.checkSendWay,trigger:'change'}],
      outfileimport:[{required: true,validator: this.checkOutFileCount, trigger: 'blur' }]
    }
    checkOutFileCount(rule, value, callback){
       if (this.currentModel.outFileName.length===0) {
         callback(new Error('请先上传发函文件'));
       }else {
         callback();
       }
    }
    checkSendWay(rule, value, callback){
       if (!this.currentModel.sendWay||this.currentModel.sendWay=="") {
         callback(new Error('请选择发函方式'));
       }else {
         callback();
       }
    }
    cellClick(row,column,cell) {
      this.indexRow = row.index;
      this.indexCol = column.index;
      this.$nextTick(() => {
        if(column.index===4){
          if(this.$refs["amount"+this.indexRow]){
            (this.$refs["amount"+this.indexRow] as any).focus();
          }
        }
        if(column.index===6){
          if(this.$refs["remark"+this.indexRow]){
            (this.$refs["remark"+this.indexRow] as any).focus();
          }
        }
      });
    }

    updateamount(e,index){
      let changeValue=e.target.value.replace(/,/g, '').replace(/\s+/g, '');
      if(!/^-?\d*\.?\d+$/.test(changeValue)){
        this.currentModel.letterAmount[index].amount2='0';
      }
      else{
        this.currentModel.letterAmount[index].amount2=Number(changeValue).toFixed(2);
        this.currentModel.letterAmount[index].amount3=Number(Number(this.currentModel.letterAmount[index].amount1)-Number(changeValue)).toFixed(2);
      }
      this.indexRow="";
      this.indexCol="";
    }
    updateremark(e,index){
      let changeValue=e.target.value;
      this.currentModel.letterAmount[index].remarks=changeValue;
      this.indexRow="";
      this.indexCol="";
    }
    formatCurrency (num) {
        return Util.format.amount(num);
    }
    async itemChange(){}
    visibleChange(value) {
      if (!value) {
        (this.$refs["uploadRef"] as any).resetFields();
        this.$emit('input',false);
      }
      else{
        this.getItem();
      }
    }
    fileonChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$alert('上传文件不能超过99M','提示',{type:'info'});
        fileList.pop();
      }
      this.currentModel.outFileName = fileList.slice(-1);
      (this.$refs["uploadRef"] as any).validateField('outfileimport');
  }
  fileonRemove (file, fileList) {
    this.currentModel.outFileName = fileList;
  }
  fileonDelete (file) {
     this.currentModel.outFileName=[];
  }
    onChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 100;
       if (!isLt2M) {
         this.$message.error('上传文件不能超过100M');
         fileList.pop();
       }
       this.currentModel.letterReply = fileList;
      }
    onRemove (file, fileList) {
      this.currentModel.letterReply = fileList;
    }
     async DownOutFile(row:any){
      if(row.status=='complete'){
        this.downloading=true;
        let currid=this.$store.state.jobdo.currjob;
        await this.$store.dispatch({
            type:'hzletter/downOutFile',
            data:{id:row.hzId,projectid:currid,filename:row.name}
        });
        this.downloading=false;
      }
    }
    async DownInFile(row:any){
        this.downloading=true;
        let currid=this.$store.state.jobdo.currjob;
        let exts=row.name.split('.').pop();
        if(exts=='eml'){
            this.messageid=row.id;
            this.pid=currid;
            this.titlename=row.name;
            this.readShow=true;
        }
        else{
          await this.$store.dispatch({
              type:'hzletter/downInFile',
              data:{id:row.letterId,value:row.id,projectid:currid,filename:row.name}
          });
        }
        this.downloading=false;
    }
    handleFileRemove(file) {
      if(!this.jobauth){
       this.$alert('无法操作，当前项目处于锁定状态。','提示',{type:'info'});
       return;
    }
    let fileid=file.id;
    let filename=file.name;
    let fileletterid=file.letterId;
    let currid=this.$store.state.jobdo.currjob;
    this.$Modal.confirm({
             title:'提示',
             content:'确定要删除该【'+filename+'】文件吗？',
             okText:'确定',
             cancelText:'取消',
             onOk:async()=>{
                 if(currid!="0"){
                     let response=await this.$store.dispatch({
                         type:'hzletter/delreply',
                         data:{ProjectId:currid,ReplyId:fileid,HzId:fileletterid}
                     });
                     if(response.success){
                         this.$message({
                             type: 'info',
                             message: '已删除'
                         });
                         await this.getItem();
                     }
                     else{
                         this.$message({
                             type: 'info',
                             message: response.message
                         });
                     }
                 }
             }
     }) 
   }
   async del(){
      var currid=this.$store.state.jobdo.currjob;
        let response=await this.$store.dispatch({
            type:'hzletter/deleteletter',
            data:{ProjectId:currid,HzId:this.letterid}
        });
        if(response.success){
            this.$message({
              message: '已删除',
              type: 'success'
            });
            this.loading=false;
            (this.$refs["uploadRef"] as any).resetFields();
            this.$emit('input',false);
            this.$emit('save-success');
        }
        else{
            this.$alert(response.message,'提示',{type:'info'});
            this.loading=false;
        }
    }
    cancel(){
      (this.$refs["uploadRef"] as any).resetFields();
      this.$emit('input',false);
    }
    async getItem(){
      this.loadingInstance=true;
       let currid=this.$store.state.jobdo.currjob;
       var response=await this.$store.dispatch({
           type:'hzletter/getitem',
           data:{Id:currid,LetterId:this.letterid}
       });
       if(response.length>0){
          this.currentModel=Util.extend(true,{},response[0]);
          this.currentStatus=Number(this.currentModel.statusId)-2;
          this.statusBtn=Number(this.currentModel.statusId);
          this.title=this.currentModel.projectName+'>往来函证>'+this.currentModel.contactName;
          if(Number(this.currentModel.statusId)>3){
            this.isreply=true;
          }
          else{
            this.isreply=false;
          }
          this.isfile=false;this.isalert=false;
          if(this.currentModel.letterReply != null && this.currentModel.letterReply.length>0){
              this.currentModel.letterReply.forEach(file=>{
                if(file.isAlert=='0'){
                  this.isfile=true;
                }
                if(file.isAlert==='1'){
                  this.isalert=true;
                }
              })
          }
       } 
       this.loadingInstance=false;
   }
   async approval(){
    (this.$refs["uploadRef"] as any).validate(async (valid) => {
          if(valid){
           this.loading=true;
           var currid=this.$store.state.jobdo.currjob;
           var formData = new FormData(); 
           this.currentModel.outFileName.forEach(file => { 
               if(file.status=='ready'){
                 formData.append('outFile', file.raw, file.raw.name); 
               }
           })
           formData.append('currId',currid);
           formData.append('hzId',this.letterid);
           formData.append('sendWay',this.currentModel.sendWay);
           let response=await this.$store.dispatch({
               type:'hzletter/approvalletter',
               data:formData
           });
           if(response.success){
               this.$message({
                 message: '已核准',
                 type: 'success'
               });
               this.loading=false;
               (this.$refs["uploadRef"] as any).resetFields();
                this.$emit('input',false);
               this.$emit('save-success');
           }
           else{
               this.$alert(response.message,'提示',{type:'info'});
               this.loading=false;
           }
          }
    });
   }
   async send(){
        this.loading=true;
        var currid=this.$store.state.jobdo.currjob;
        let response=await this.$store.dispatch({
            type:'hzletter/sendletter',
            data:{ProjectId:currid,HzId:this.letterid}
        });
        if(response.success){
            this.$message({
              message: '已发送',
              type: 'success'
            });
            this.loading=false;
            (this.$refs["uploadRef"] as any).resetFields();
            this.$emit('input',false);
            this.$emit('save-success');
        }
        else{
            this.$alert(response.message,'提示',{type:'info'});
            this.loading=false;
        }
   }
   async save() {
      if (this.currentModel.letterReply.length > 0) {
        this.loading=true;
           var currid=this.$store.state.jobdo.currjob;
           let response=await this.$store.dispatch({
               type:'hzletter/saveletter',
               data:{ProjectId:currid,HzId:this.letterid,ExecNotes:this.currentModel.execNotes,AlertNotes:this.currentModel.alertNotes,AmountLines:JSON.stringify(this.currentModel.letterAmount)}
           });
           if(response.success){
               this.$message({
                 message: '已确认',
                 type: 'success'
               });
               this.loading=false;
               (this.$refs["uploadRef"] as any).resetFields();
                this.$emit('input',false);
               this.$emit('save-success');
           }
           else{
               this.$alert(response.message,'提示',{type:'info'});
               this.loading=false;
           }					
        } else {
          this.$message.error('请先上传回函文件或替代程序底稿');
          this.loading=false;
        }
    }
    async created(){
    }
    async mounted(){
       const that = this;
       var modalH=window.innerHeight-188;
       var erd = elementResizeDetector();
       erd.listenTo(document.querySelectorAll("#letteredit .ivu-modal-content"), (element) => {              
        that.$nextTick(() => { 
            let ivumodal=$(".modal-letter > div.ivu-modal");
            if(ivumodal){
              if(that.isreply){
                ivumodal.css('top','45px');
              }
              else{
                ivumodal.css('top','100px');
              }
            }
            let modalbody=$(".modal-letter > div.ivu-modal > div.ivu-modal-content > div.ivu-modal-body");
            if(modalbody){
               if(that.isreply){
                if(modalH<480){
                  modalbody.css('max-height','480px');
                }
                else{
                  modalbody.css('max-height',modalH+'px');
                }
               } 
               else{
                  modalbody.css('max-height','480px');
               }
            }
        });
      });
    }
}
  